<ng-container [ngSwitch]="phase">
  <div *ngSwitchCase="'start'">
    <sbnb-connect-booking-choose-method></sbnb-connect-booking-choose-method>
  </div>

  <sbnb-connect-booking-disclaimer
    *ngSwitchCase="'requirements'"
    (stepComplete)="handlePhase('booking-widget')"></sbnb-connect-booking-disclaimer>

  <sbnb-connect-booking-requirements-fail
    *ngSwitchCase="'requirements-fail'"
    (stepComplete)="handlePhase($event)"></sbnb-connect-booking-requirements-fail>

  <sbnb-connect-booking-widget *ngSwitchCase="'booking-widget'"></sbnb-connect-booking-widget>

  <sbnb-connect-booking-property-ids
    *ngSwitchCase="'property-ids'"
    (propertiesEmitter)="initReviewPropertiesScreen($event)"></sbnb-connect-booking-property-ids>

  <sbnb-connect-booking-review-properties
    *ngSwitchCase="'review-properties'"
    [propertyIds]="propertyIds"
    (propertiesEmitter)="initPricingScreen($event)"
    (noPropertyIdsEmitter)="initPropertyIdsScreen()"></sbnb-connect-booking-review-properties>

  <sbnb-connect-pricing
    *ngSwitchCase="'set-markup'"
    [propertyIds]="propertyIds"
    (stepComplete)="setMarkupCompleted($event)"
    (noPropertyIdsEmitter)="initPropertyIdsScreen()"></sbnb-connect-pricing>

  <sbnb-connect-done
    *ngSwitchCase="'done'"
    platform="booking"></sbnb-connect-done>
</ng-container>
